module.exports = __webpack_public_path__ + "img/yancao_shifang.ea988c4e.png";